import enGroupUser from "./en/groupuser.json";
import viGroupUser from "./vi/groupuser.json";
import enStorageManagementContainer from "./en/storagemanagementcontainer.json";
import viStorageManagementContainer from "./vi/storagemanagementcontainer.json";
import enSystemSettingTab from "./en/systemsettingtab.json";
import viSystemSettingTab from "./vi/systemsettingtab.json";
import enStorageItemCard from "./en/storageitemcard.json";
import viStorageItemCard from "./vi/storageitemcard.json";
import enBatchEditModal from "./en/batcheditmodal.json";
import viBatchEditModal from "./vi/batcheditmodal.json";
import enStorageToolbar from "./en/storagetoolbar.json";
import viStorageToolbar from "./vi/storagetoolbar.json";
import enFilterModal from "./en/filtermodal.json";
import viFilterModal from "./vi/filtermodal.json";
import enGroupUserTab from "./en/groupusertab.json";
import viGroupUserTab from "./vi/groupusertab.json";
import enGroupMemberModal from "./en/groupmembermodal.json";
import viGroupMemberModal from "./vi/groupmembermodal.json";
import enGroupDetailPage from "./en/groupdetailpage.json";
import viGroupDetailPage from "./vi/groupdetailpage.json";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enLogin from "./en/login.json";
import viLogin from "./vi/login.json";
import enSidebar from "./en/sidebar.json";
import viSidebar from "./vi/sidebar.json";
import enHeader from "./en/header.json";
import viHeader from "./vi/header.json";
import enSearch from "./en/search.json";
import viSearch from "./vi/search.json";
import enFiles from "./en/files.json";
import viFiles from "./vi/files.json";
import enFilesPage from "./en/files_page.json";
import viFilesPage from "./vi/files_page.json";
import enContextMenu from "./en/contextMenu.json";
import viContextMenu from "./vi/contextMenu.json";
import enPageHeader from "./en/pageheader.json";
import viPageHeader from "./vi/pageheader.json";
import enInfoPanel from "./en/infopanel.json";
import viInfoPanel from "./vi/infopanel.json";
import enFilePanel from "./en/filepanel.json";
import viFilePanel from "./vi/filepanel.json";
import enInfoTabs from "./en/infotabs.json";
import viInfoTabs from "./vi/infotabs.json";
import enErrors from "./en/errors.json";
import viErrors from "./vi/errors.json";
import enShare from "./en/share.json";
import viShare from "./vi/share.json";
import enMove from "./en/move.json";
import viMove from "./vi/move.json";
import enJobsModal from "./en/jobsmodal.json";
import viJobsModal from "./vi/jobsmodal.json";
import enUploadModal from "./en/uploadmodal.json";
import viUploadModal from "./vi/uploadmodal.json";
import enUploadLog from "./en/uploadlog.json";
import viUploadLog from "./vi/uploadlog.json";
import enFileConflict from "./en/fileconflict.json";
import viFileConflict from "./vi/fileconflict.json";
import enImportFileFooter from "./en/importfilefooter.json";
import viImportFileFooter from "./vi/importfilefooter.json";
import enUploadListItem from "./en/uploadlistitem.json";
import viUploadListItem from "./vi/uploadlistitem.json";
import enInfoActivity from "./en/infoactivity.json";
import viInfoActivity from "./vi/infoactivity.json";
import enPermissionDropdown from "./en/permissiondropdown.json";
import viPermissionDropdown from "./vi/permissiondropdown.json";
import enContextMenuMessages from "./en/contextmenumessages.json";
import viContextMenuMessages from "./vi/contextmenumessages.json";
import enRenameModal from "./en/renamemodal.json";
import viRenameModal from "./vi/renamemodal.json";
import enUserDropdown from "./en/userdropdown.json";
import viUserDropdown from "./vi/userdropdown.json";
import enDrawingsPage from "./en/drawingspage.json";
import viDrawingsPage from "./vi/drawingspage.json";
import enTrashPage from "./en/trashpage.json";
import viTrashPage from "./vi/trashpage.json";
import enFilesTableSection from "./en/filestablesection.json";
import viFilesTableSection from "./vi/filestablesection.json";
import enTeamDrivesPage from "./en/teamdrivespage.json";
import viTeamDrivesPage from "./vi/teamdrivespage.json";
import enFileInfo from "./en/fileInfo.json";
import viFileInfo from "./vi/fileInfo.json";
import enUploadDebugPanel from "./en/upload_debug_panel.json";
import viUploadDebugPanel from "./vi/upload_debug_panel.json";
import enStorage from "./en/storage.json";
import viStorage from "./vi/storage.json";
import enAddMemberModal from "./en/addmembermodal.json";
import viAddMemberModal from "./vi/addmembermodal.json";
import enGroupCard from "./en/groupcard.json";
import viGroupCard from "./vi/groupcard.json";
import viProfile from "./vi/profile.json";
import enProfile from "./en/profile.json";

const detector = new LanguageDetector();

// Ưu tiên ngôn ngữ từ Google Translate cookie (googtrans=/en/vi) nếu có
detector.addDetector({
  name: "googleTranslateDetector",
  lookup() {
    const match = document?.cookie?.match(/(?:^|; )googtrans=([^;]+)/);
    if (!match) return undefined;
    const value = decodeURIComponent(match[1]);
    const parts = value.split("/").filter(Boolean); // ["en", "vi"]
    const lng = parts[parts.length - 1]?.toLowerCase();
    return lng || undefined;
  },
});

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    interpolation: { escapeValue: false },
    lng: "vi",
    fallbackLng: "vi",
    supportedLngs: ["en", "vi"],
    load: "languageOnly", // Map vi-VN -> vi
    detection: {
      order: [
        "localStorage",
        "googleTranslateDetector",
        "htmlTag",
        "path",
        "subdomain",
      ],
      caches: ["localStorage"],
    },
    resources: {
      en: {
        login: enLogin,
        sidebar: enSidebar,
        header: enHeader,
        search: enSearch,
        files: enFiles,
        files_page: enFilesPage,
        contextMenu: enContextMenu,
        pageheader: enPageHeader,
        infopanel: enInfoPanel,
        filepanel: enFilePanel,
        infotabs: enInfoTabs,
        errors: enErrors,
        share: enShare,
        move: enMove,
        jobsmodal: enJobsModal,
        uploadmodal: enUploadModal,
        uploadlog: enUploadLog,
        fileconflict: enFileConflict,
        importfilefooter: enImportFileFooter,
        uploadlistitem: enUploadListItem,
        infoactivity: enInfoActivity,
        permissiondropdown: enPermissionDropdown,
        contextmenumessages: enContextMenuMessages,
        renamemodal: enRenameModal,
        userdropdown: enUserDropdown,
        drawingspage: enDrawingsPage,
        trashpage: enTrashPage,
        filestablesection: enFilesTableSection,
        teamdrivespage: enTeamDrivesPage,
        fileInfo: enFileInfo,
        upload_debug_panel: enUploadDebugPanel,
        storage: enStorage,
        addmembermodal: enAddMemberModal,
        groupcard: enGroupCard,
        groupdetailpage: enGroupDetailPage,
        groupmembermodal: enGroupMemberModal,
        groupusertab: enGroupUserTab,
        filtermodal: enFilterModal,
        storagetoolbar: enStorageToolbar,
        batcheditmodal: enBatchEditModal,
        storageitemcard: enStorageItemCard,
        systemsettingtab: enSystemSettingTab,
        storagemanagementcontainer: enStorageManagementContainer,
        groupuser: enGroupUser,
        profile: enProfile,
      },
      vi: {
        login: viLogin,
        sidebar: viSidebar,
        header: viHeader,
        search: viSearch,
        files: viFiles,
        files_page: viFilesPage,
        contextMenu: viContextMenu,
        pageheader: viPageHeader,
        infopanel: viInfoPanel,
        filepanel: viFilePanel,
        infotabs: viInfoTabs,
        errors: viErrors,
        share: viShare,
        move: viMove,
        jobsmodal: viJobsModal,
        uploadmodal: viUploadModal,
        uploadlog: viUploadLog,
        fileconflict: viFileConflict,
        importfilefooter: viImportFileFooter,
        uploadlistitem: viUploadListItem,
        infoactivity: viInfoActivity,
        permissiondropdown: viPermissionDropdown,
        contextmenumessages: viContextMenuMessages,
        renamemodal: viRenameModal,
        userdropdown: viUserDropdown,
        drawingspage: viDrawingsPage,
        trashpage: viTrashPage,
        filestablesection: viFilesTableSection,
        teamdrivespage: viTeamDrivesPage,
        fileInfo: viFileInfo,
        upload_debug_panel: viUploadDebugPanel,
        storage: viStorage,
        addmembermodal: viAddMemberModal,
        groupcard: viGroupCard,
        groupdetailpage: viGroupDetailPage,
        groupmembermodal: viGroupMemberModal,
        groupusertab: viGroupUserTab,
        filtermodal: viFilterModal,
        storagetoolbar: viStorageToolbar,
        batcheditmodal: viBatchEditModal,
        storageitemcard: viStorageItemCard,
        systemsettingtab: viSystemSettingTab,
        storagemanagementcontainer: viStorageManagementContainer,
        groupuser: viGroupUser,
        profile: viProfile,
      },
    },
  });

export default i18n;
